<h2 mat-dialog-title>
  {{ isReadOnly ? 'Consulter la Fiche d\'Expression de Besoin' : (isEditMode ? 'Modifier la Fiche d\'Expression de
  Besoin' : 'Nouvelle Fiche d\'Expression de Besoin')
  }}
</h2>

<!-- Erreur backend -->
<div *ngIf="backendError" class="backend-error-banner">
  <mat-icon>error_outline</mat-icon>
  <span>{{ backendError }}</span>
</div>

<div *ngIf="isReadOnly" class="readonly-banner">
  {{ readonlyMessage }}
</div>

<mat-dialog-content class="dialog-content">
  <mat-stepper linear="true" #stepper orientation="horizontal">

    <!-- ══════════════════════════════════════════════════════════════
        ÉTAPE 1 — Acteurs & Informations générales
    ══════════════════════════════════════════════════════════════ -->
    <mat-step [stepControl]="step1Form" label="Acteurs & Informations">
      <form [formGroup]="step1Form" class="step-form">

        <mat-form-field appearance="outline" color="accent" class="full-width">
          <mat-label>Label de la FEB</mat-label>
          <input matInput formControlName="febLabel" placeholder="Libellé de la fiche d'expression de besoin..."
            maxlength="100">
          <mat-error *ngIf="step1Form.get('febLabel')?.hasError('required')">Champ obligatoire</mat-error>
          <mat-hint align="end"> {{ (step1Form.get('febLabel')?.value?.length || 0) + '/100 caractères' }}</mat-hint>
          <mat-error *ngIf="step1Form.get('febLabel')?.hasError('maxlength')">Maximum 100 caractères</mat-error>
        </mat-form-field>

        <div class="row-fields">
          <!-- Pilote de lot -->
          <mat-form-field appearance="outline" color="accent" class="half-width">
            <mat-label>Pilote de lot</mat-label>
            <input matInput formControlName="febPilotLotSearch" [matAutocomplete]="autoPilot"
              placeholder="Rechercher un utilisateur...">
            <mat-autocomplete #autoPilot="matAutocomplete">
              <mat-option *ngFor="let u of filteredPilots | async"
                [value]="(u.firstName ?? '') + ' ' + (u.lastName ?? '')" (onSelectionChange)="selectPilot(u)">
                {{ u.firstName }} {{ u.lastName }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <!-- Demandeur -->
          <mat-form-field appearance="outline" color="accent" class="half-width">
            <mat-label>Demandeur</mat-label>
            <input matInput formControlName="febDemandeurSearch" [matAutocomplete]="autoDemandeur"
              placeholder="Rechercher un utilisateur...">
            <mat-autocomplete #autoDemandeur="matAutocomplete">
              <mat-option *ngFor="let u of filteredDemandeurs | async"
                [value]="(u.firstName ?? '') + ' ' + (u.lastName ?? '')" (onSelectionChange)="selectDemandeur(u)">
                {{ u.firstName }} {{ u.lastName }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="row-fields">
          <!-- Entité SNCF -->
          <mat-form-field appearance="outline" color="accent" class="half-width">
            <mat-label>Entité SNCF</mat-label>
            <mat-select formControlName="febEntiteSncfId">
              <mat-option [value]="null">— Aucune —</mat-option>
              <mat-option *ngFor="let d of cdsEntities" [value]="d.id">{{ d.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Division du demandeur -->
          <mat-form-field appearance="outline" color="accent" class="half-width">
            <mat-label>Division du demandeur</mat-label>
            <mat-select formControlName="febDivisionDemandeurId">
              <mat-option [value]="null">— Aucune —</mat-option>
              <mat-option *ngFor="let d of dsiDivisions" [value]="d.id">{{ d.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Projet -->
        <mat-form-field appearance="outline" color="accent" class="full-width">
          <mat-label>Projet</mat-label>
          <mat-select formControlName="febProjectId">
            <mat-option [value]="null">— Aucun —</mat-option>
            <mat-option *ngFor="let p of projects" [value]="p.id">{{ p.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row-fields">
          <!-- Date de la demande -->
          <mat-form-field appearance="outline" color="accent" class="third-width">
            <mat-label>Date de la demande</mat-label>
            <input matInput [matDatepicker]="pickerDemande" formControlName="febDateDemande">
            <mat-datepicker-toggle matIconSuffix [for]="pickerDemande"></mat-datepicker-toggle>
            <mat-datepicker #pickerDemande></mat-datepicker>
          </mat-form-field>

          <!-- Date de démarrage -->
          <mat-form-field appearance="outline" color="accent" class="third-width">
            <mat-label>Date de démarrage</mat-label>
            <input matInput [matDatepicker]="pickerDemarrage" formControlName="febDateDemarrage">
            <mat-datepicker-toggle matIconSuffix [for]="pickerDemarrage"></mat-datepicker-toggle>
            <mat-datepicker #pickerDemarrage></mat-datepicker>
          </mat-form-field>

          <!-- Date de fin prévisionnelle -->
          <mat-form-field appearance="outline" color="accent" class="third-width">
            <mat-label>Date fin prévisionnelle</mat-label>
            <input matInput [matDatepicker]="pickerFin" formControlName="febDateFinPrevisionnelle">
            <mat-datepicker-toggle matIconSuffix [for]="pickerFin"></mat-datepicker-toggle>
            <mat-datepicker #pickerFin></mat-datepicker>
          </mat-form-field>
        </div>

        <p *ngIf="step1Form.hasError('dateRange')" class="field-error">
          <mat-icon class="field-error-icon">error</mat-icon>
          La date de fin prévisionnelle ne peut être avant la date de démarrage
        </p>
        <p *ngIf="hasDateWarning" class="field-warning">
          <mat-icon class="field-warning-icon">warning</mat-icon>
          Attention : la date de la demande est après la date de démarrage
        </p>
        <div class="row-fields">
          <mat-form-field appearance="outline" color="accent" class="half-width">
            <mat-label>Localisation de mission</mat-label>
            <mat-select formControlName="febLocalisationId">
              <mat-option [value]="null">— Aucune —</mat-option>
              <mat-option *ngFor="let l of localisations" [value]="l.id">{{ l.localisationLabel }}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Durée d'intervention -->
          <!-- Durée d'intervention -->
          <mat-form-field appearance="outline" color="accent" class="half-width">
            <mat-label>Durée d'intervention (jours)</mat-label>
            <input matInput formControlName="febDuree" type="number" min="0" step="0.1">
            <span matSuffix>jours</span>
            <mat-error *ngIf="step1Form.get('febDuree')?.errors?.['required']">
              Le champ est obligatoire
            </mat-error>
            <mat-error *ngIf="step1Form.get('febDuree')?.errors?.['min']">
              La durée doit être supérieure à 0
            </mat-error>
          </mat-form-field>
        </div>

        <div class="checkbox-row">
          <mat-checkbox formControlName="febPcSncf" color="primary">PC SNCF fourni</mat-checkbox>
        </div>

        <div class="step-actions">
          <button mat-raised-button color="primary" matStepperNext [disabled]="step1Form.invalid">
            Suivant <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>
      </form>
    </mat-step>

    <!-- ══════════════════════════════════════════════════════════════
        ÉTAPE 2 — Nomenclature & Description
    ══════════════════════════════════════════════════════════════ -->
    <mat-step [stepControl]="step2Form" label="Nomenclature & Description">
      <form [formGroup]="step2Form" class="step-form">

        <mat-form-field appearance="outline" color="accent" class="flex-grow">
          <mat-label>Activité UO / Nomenclature</mat-label>
          <input matInput formControlName="febNomenclatureSearch" [matAutocomplete]="autoNom"
            placeholder="Rechercher par activité ou nomenclature...">
          <mat-autocomplete #autoNom="matAutocomplete">
            <mat-option *ngFor="let n of filteredNomenclatures | async"
              [value]="(n.activiteUOoperationnelle ?? '') + ' — ' + (n.nomenclatureLabel ?? '')"
              (onSelectionChange)="selectNomenclature(n)">
              <span class="nom-option-activite">{{ n.activiteUOoperationnelle }}</span>
              <span class="nom-option-sep"> — </span>
              <span class="nom-option-label">{{ n.nomenclatureLabel }}</span>
              <span class="nom-option-prix"> ({{ n.prixUO }}€ / {{ n.prixUOmajore }}€ maj.)</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" color="accent" class="full-width">
          <mat-label>Nomenclature (récupérée automatiquement)</mat-label>
          <input matInput formControlName="febNomenclature" readonly
            placeholder="Sélectionnez une activité UO ci-dessus...">
          <mat-icon matSuffix matTooltip="Ce champ est rempli automatiquement depuis la sélection UO">lock</mat-icon>
        </mat-form-field>

        <div class="row-fields">
          <mat-form-field appearance="outline" color="accent" class="half-width">
            <mat-label>Présence site SNCF / Télétravail</mat-label>
            <input matInput formControlName="febPresenceSiteSncf" placeholder="Ex: Présentiel, Télétravail, Hybride..."
              maxlength="50">
            <mat-hint align="end"> {{ (step2Form.get('febPresenceSiteSncf')?.value?.length || 0) + '/50 caractères'
              }}</mat-hint>
            <mat-error *ngIf="step2Form.get('febPresenceSiteSncf')?.hasError('maxlength')">Maximum 50
              caractères</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" color="accent" class="half-width">
            <mat-label>Provisionnement déplacement et astreinte</mat-label>
            <input matInput type="number" min="0" formControlName="febProvisionDeplacementAstreinte">
            <mat-icon matSuffix matTooltip="Montant en euros pour le provisionnement des déplacements et astreintes">euro</mat-icon>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" color="accent" class="full-width">
          <mat-label>Contexte et objectif du projet</mat-label>
          <textarea matInput formControlName="febContexteObjectifProjet" cdkTextareaAutosize cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="10" placeholder="Décrivez le contexte et les objectifs du projet..."></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" color="accent" class="full-width">
          <mat-label>Description du besoin</mat-label>
          <textarea matInput formControlName="febDescriptionBesoin" cdkTextareaAutosize cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="10" placeholder="Décrivez le besoin de manière détaillée..."></textarea>
        </mat-form-field>

        <div class="step-actions">
          <button mat-button matStepperPrevious>
            <mat-icon>arrow_back</mat-icon> Précédent
          </button>
          <button mat-raised-button color="primary" matStepperNext [disabled]="step2Form.invalid">
            Suivant <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>
      </form>
    </mat-step>

    <!-- ══════════════════════════════════════════════════════════════
        ÉTAPE 3 — Activités & Compétences
    ══════════════════════════════════════════════════════════════ -->
    <mat-step [stepControl]="step3Form" label="Activités & Compétences">
      <form [formGroup]="step3Form" class="step-form">

        <!-- Section Activités -->
        <div class="section-header">
          <span class="section-title">Activités</span>
          <button mat-stroked-button color="primary" type="button" (click)="addActivite()" *ngIf="!isReadOnly">
            <mat-icon>add</mat-icon> Ajouter une activité
          </button>
        </div>

        <div formArrayName="activites" class="activites-list">
          <div *ngFor="let act of activitesArray.controls; let i = index" [formGroupName]="i" class="activite-row">
            <mat-form-field appearance="outline" color="accent" class="activite-label-field">
              <mat-label>Label de l'activité</mat-label>
              <input matInput formControlName="label" placeholder="Ex: Développement front-end">
              <mat-error *ngIf="act.get('label')?.hasError('required')">Obligatoire</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" color="accent" class="activite-pct-field">
              <mat-label>ventilation</mat-label>
              <input matInput formControlName="pourcentage" type="number" min="0" max="100">
              <span matSuffix>%</span>
              <mat-error *ngIf="act.get('pourcentage')?.hasError('required')">Obligatoire</mat-error>
              <mat-error
                *ngIf="act.get('pourcentage')?.hasError('min') || act.get('pourcentage')?.hasError('max')">0–100</mat-error>
            </mat-form-field>

            <button mat-icon-button color="warn" type="button" (click)="removeActivite(i)" matTooltip="Supprimer"
              *ngIf="!isReadOnly">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <p *ngIf="activitesArray.length === 0 && !isReadOnly" class="empty-hint">
            Aucune activité ajoutée — cliquez sur "Ajouter une activité" pour commencer.
          </p>
          <p *ngIf="activitesArray.length === 0 && isReadOnly" class="empty-hint">
            Aucune activité renseignée.
          </p>

          <div *ngIf="activitesArray.length > 0" class="activites-total"
            [class.activites-total-ok]="activitesTotal === 100" [class.activites-total-error]="activitesTotal !== 100">
            <mat-icon>{{ activitesTotal === 100 ? 'check_circle' : 'error' }}</mat-icon>
            Total : {{ activitesTotal }}% / 100%
          </div>

          <p *ngIf="step3Form.hasError('activitesTotalNot100') && activitesArray.length > 0" class="field-error">
            <mat-icon class="field-error-icon">error</mat-icon>
            La somme des ventilations doit être égale à 100% (actuellement : {{ activitesTotal }}%).
          </p>
        </div>

        <!-- Section Compétences requises -->
        <div class="section-header" style="margin-top: 16px;">
          <span class="section-title">Compétences requises</span>
        </div>

        <mat-form-field appearance="outline" color="accent" class="full-width">
          <mat-label>Nombre d'années d'expériences</mat-label>
          <textarea matInput formControlName="febNbAnneesExperiences" placeholder="Ex: 3-5 ans" cdkTextareaAutosize
            cdkAutosizeMinRows="3" cdkAutosizeMaxRows="6"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" color="accent" class="full-width">
          <mat-label>Compétences fonctionnelles</mat-label>
          <textarea matInput formControlName="febCompetencesFonctionnelles" cdkTextareaAutosize cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="6"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" color="accent" class="full-width">
          <mat-label>Compétences techniques</mat-label>
          <textarea matInput formControlName="febCompetencesTechniques" cdkTextareaAutosize cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="6"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" color="accent" class="full-width">
          <mat-label>Environnement technique</mat-label>
          <textarea matInput formControlName="febEnvironnementTechnique" cdkTextareaAutosize cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="6"></textarea>
        </mat-form-field>

        <!-- Section Savoir-être -->
        <div class="section-header">
          <span class="section-title">Savoir-être et qualités</span>
        </div>

        <mat-form-field appearance="outline" color="accent" class="full-width">
          <mat-label>Savoir-être et qualités</mat-label>
          <textarea matInput formControlName="febSavoirEtreQualites" cdkTextareaAutosize cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="6" placeholder="Ex: Autonomie, rigueur, esprit d'équipe..."></textarea>
        </mat-form-field>

        <div class="step-actions">
          <button mat-button matStepperPrevious>
            <mat-icon>arrow_back</mat-icon> Précédent
          </button>
        </div>
      </form>
    </mat-step>

  </mat-stepper>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Fermer</button>
  <button *ngIf="!isReadOnly" mat-raised-button color="primary" type="button" (click)="onSubmit()"
    [disabled]="step1Form.invalid || step2Form.invalid || step3Form.invalid">
    <mat-icon>{{ isEditMode ? 'save' : 'add' }}</mat-icon>
    {{ isEditMode ? 'Modifier' : 'Créer' }}
  </button>
</mat-dialog-actions>